// src/components/AuthRoutes.js
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./auth";
import { Switch } from "./router";
import IndexPage from "../pages/index";
import AboutPage from "../pages/about";
import FaqPage from "../pages/faq";
import ContactPage from "../pages/contact";
import PricingPage from "../pages/pricing";
import DashboardPage from "../pages/dashboard";
import AuthPage from "../pages/auth";
import SettingsPage from "../pages/settings";
import LegalPage from "../pages/legal";
import VerifyPage from "../pages/verify";
import EnterShowInfoPage from "../pages/enter-show-info";
import LegalMobilePage from "../pages/legalMobilePage";
import PurchasePage from "../pages/purchase";
import FirebaseActionPage from "../pages/firebase-action";
import NotFoundPage from "../pages/404";
import { Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { user, isAuthInitializing } = useAuth();

  if (isAuthInitializing) {
    return     <Box textAlign="center" mt={10}>
        <CircularProgress />
    </Box>
  }

  // Only render the Route once we know the user state
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Component {...props} /> : <Redirect to="/auth/signin" />
      }
    />
  );
};

export const PublicRoute = ({ component: Component, ...rest }) => {
  const { user, isAuthInitializing } = useAuth();

//   if (isAuthInitializing) {
//     return <div>Loading...</div>; // wait until Firebase restores session
//   }

  // Only render the Route once we know the user state
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Redirect to="/dashboard" /> : <Component {...props} />
      }
    />
  );
};

function AuthRoutes(props) { 
  const { isAuthInitializing } = useAuth();

//   if (isAuthInitializing) {
//     return <div>Loading...</div>; // block initial render
//   }

  return (
              <Switch>
                <PublicRoute exact path="/" component={IndexPage} />

                <Route exact path="/about" component={AboutPage} />

                <Route exact path="/faq" component={FaqPage} />

                <Route exact path="/contact" component={ContactPage} />

                <ProtectedRoute exact path="/pricing" component={PricingPage} />

                <ProtectedRoute exact path="/dashboard" component={DashboardPage} />

                <ProtectedRoute exact path="/enter-show-info" component={EnterShowInfoPage} />

                <ProtectedRoute exact path="/auth/verify" component={VerifyPage} />

                <PublicRoute exact path="/auth/:type" component={AuthPage} />

                <ProtectedRoute
                  exact
                  path="/settings/:section"
                  component={SettingsPage}
                />

                {/* <Route exact path="/legal/:section" component={LegalPage} /> */}

                <Route exact path="/legalMobilePage" component={LegalMobilePage} />

                <ProtectedRoute exact path="/purchase/:plan" component={PurchasePage} />

                <Route
                  exact
                  path="/firebase-action"
                  component={FirebaseActionPage}
                />

                <PublicRoute component={NotFoundPage} />
              </Switch>
  );
}

export default AuthRoutes;
